import {useState} from "react";
import {API_BASE_URL} from "../ConstantsAndHelper";

function ActualCourse({actualCourse, encodedAuthHeader}) {
    const [courseCategory, setCourseCategory] = useState("lecture");
    let {lectures, exercises, quizzes} = actualCourse;

    function setCategoryToLecture(e) {
        e.preventDefault();
        setCourseCategory("lecture");
    }

    function setCategoryToQuiz(e) {
        e.preventDefault();
        setCourseCategory("quiz");
    }

    function setCategoryToExercise(e) {
        e.preventDefault();
        setCourseCategory("exercise");
    }

    function setMainAccordionAndLinks(lectureClass, exerciseClass, quizClass) {
        lectureLinkClassName = lectureClass;
        exerciseLinkClassName = exerciseClass;
        quizLinkClassName = quizClass;
    }

    let lectureLinkClassName;
    let exerciseLinkClassName;
    let quizLinkClassName;
    let moduleList;
    if (courseCategory === "exercise") {
        moduleList = exercises;
        setMainAccordionAndLinks("nav-link", "nav-link active", "nav-link");
    } else if (courseCategory === "quiz") {
        moduleList = quizzes;
        setMainAccordionAndLinks("nav-link", "nav-link", "nav-link active");
    } else {
        moduleList = lectures;
        setMainAccordionAndLinks("nav-link active", "nav-link", "nav-link");
    }


    let courseContent = <div className="spinner-border" role="status"><span
        className="visually-hidden">Loading...</span></div>;
    if ((lectures !== null) && (exercises !== null) && (quizzes !== null)) {
        let listItemLecture = "";
        if ((lectures.length > 0) && ((exercises.length > 0) || (quizzes.length > 0))) {
            listItemLecture = <li key="nav-item-lecture" className="nav-item" style={{margin: '0.3rem'}}>
                <a className={lectureLinkClassName} href="/#" onClick={setCategoryToLecture}><i
                    className="bi bi-easel"></i> Vorlesung</a>
            </li>;
        }

        let listItemExercise = "";
        if (exercises.length > 0) {
            listItemExercise = <li key="nav-item-exercise" className="nav-item" style={{margin: '0.3rem'}}>
                <a className={exerciseLinkClassName} href="/#" onClick={setCategoryToExercise}><i
                    className="bi bi-person-workspace"></i> Übung</a>
            </li>;
        }

        let listItemQuiz = "";
        if (quizzes.length > 0) {
            listItemQuiz = <li key="nav-item-quiz" className="nav-item" style={{margin: '0.3rem'}}>
                <a className={quizLinkClassName} href="/#" onClick={setCategoryToQuiz}><i
                    className="bi bi-question-circle"></i> Quiz</a>
            </li>;
        }

        courseContent = <div key={"courseContent-" + actualCourse.id}>
            <ul className="nav nav-underline justify-content-center" style={{marginTop: '1rem', marginBottom: '2rem'}}>
                {listItemLecture}
                {listItemExercise}
                {listItemQuiz}
            </ul>
            <MainAccordion actualCourse={actualCourse} encodedAuthHeader={encodedAuthHeader} moduleList={moduleList}
                           courseCategory={courseCategory}/>
        </div>;
    }

    return (
        <div>
            {courseContent}
        </div>
    );
}

function MainAccordion({actualCourse, encodedAuthHeader, moduleList, courseCategory}) {
    const [actualQuiz, setActualQuiz] = useState(null);
    const [showAnswer, setShowAnswer] = useState(false);
    const [userAnswers, setUserAnswers] = useState(null);
    const [userTaskResult, setUserTaskResult] = useState(<div/>);
    const [userQuizResult, setUserQuizResult] = useState({"incorrect": 0, "right": 0});

    function enterQuiz(quiz) {
        setActualQuiz(quiz);
        setShowAnswer(false);
        setUserAnswers(null);
        setUserTaskResult(<div/>);
        setUserQuizResult({"incorrect": 0, "right": 0});

        fetch(`${API_BASE_URL}/course/${actualCourse.id}/quiz/${quiz.id}/stats`, {
            method: "POST",
            headers: {
                "Authorization": encodedAuthHeader
            }
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(response.status.toString());
                }
            })
            .catch((error) => {
                // console.log('error: ' + error);
            });
    }

    function leaveActualQuiz() {
        setActualQuiz(null);
        setShowAnswer(false);
        setUserAnswers(null);
        setUserTaskResult(<div/>);
        setUserQuizResult({"incorrect": 0, "right": 0});
    }

    function fillItems(moduleList, category) {
        let itemList = [];
        let urlEncodedAuthHeader = encodeURIComponent(encodedAuthHeader);

        if (moduleList !== null) {
            for (let m of moduleList) {
                let moduleDivName = "collapse-" + category + "-" + m.id;
                let moduleFiles = [];
                let moduleDescription = "";
                if (m.description !== null && m.description !== "null") {
                    moduleDescription = m.description;
                }

                if (m.files !== undefined) {
                    for (let f of m.files) {
                        let fileTypeIcon = "";

                        if (f.mimeType.includes("pdf")) {
                            fileTypeIcon = <i className="bi bi-filetype-pdf"></i>;
                        } else if (f.mimeType.includes("csv")) {
                            fileTypeIcon = <i className="bi bi-filetype-csv"></i>;
                        } else if (f.mimeType.includes("txt")) {
                            fileTypeIcon = <i className="bi bi-filetype-txt"></i>;
                        }

                        let fileLink = <a download={f.name} target="_blank" rel="noreferrer"
                                          href={API_BASE_URL + "/course/" + actualCourse.id + "/file/" + f.id + "?c=" + urlEncodedAuthHeader}
                                          className="link-underline-primary">{fileTypeIcon} {f.name}</a>;

                        moduleFiles.push(
                            <li key={"moduleFile-" + f.id} className="list-group-item">
                                {fileLink}
                            </li>
                        );
                    }
                }

                let accordionBody;
                if (courseCategory === "quiz" && actualQuiz !== null) {
                    accordionBody = <div className="accordion-body">
                        <div dangerouslySetInnerHTML={{__html: moduleDescription}}></div>
                        <QuizCarousel actualQuiz={m} showAnswer={showAnswer} setShowAnswer={setShowAnswer}
                                      userAnswers={userAnswers} setUserAnswers={setUserAnswers}
                                      userTaskResult={userTaskResult} setUserTaskResult={setUserTaskResult}
                                      userQuizResult={userQuizResult} setUserQuizResult={setUserQuizResult}/>
                    </div>;
                } else if (courseCategory === "quiz") {
                    accordionBody = <div className="accordion-body">
                        <div dangerouslySetInnerHTML={{__html: moduleDescription}}></div>
                        <button key={"button-quiz-start-" + m.id} type="button" className="btn btn-outline-primary"
                                onClick={() => enterQuiz(m)}><i className="bi bi-play-btn"></i> Quiz starten
                        </button>
                    </div>;
                } else {
                    accordionBody = <div className="accordion-body">
                        <div dangerouslySetInnerHTML={{__html: moduleDescription}}></div>
                        <ul className="list-group">
                            {moduleFiles}
                        </ul>
                    </div>;
                }

                itemList.push(
                    <div key={"accordionItem-" + category + "-" + m.id} className="accordion-item">
                        <h2 className="accordion-header">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target={"#" + moduleDivName} aria-expanded="false"
                                    aria-controls={moduleDivName}
                                    onClick={leaveActualQuiz}>
                                {m.name}
                            </button>
                        </h2>
                        <div id={moduleDivName} className="accordion-collapse collapse"
                             data-bs-parent={"#accordion-" + category}>
                            {accordionBody}
                        </div>
                    </div>
                );
            }
        }
        return itemList;
    }

    let accordionItems = fillItems(moduleList, courseCategory);
    return (
        <div className="accordion" id={"accordion-" + courseCategory} style={{marginLeft: '3rem', marginRight: '3rem'}}>
            {accordionItems}
        </div>);
}

function QuizCarousel({
                          actualQuiz,
                          showAnswer,
                          setShowAnswer,
                          userAnswers,
                          setUserAnswers,
                          userTaskResult,
                          setUserTaskResult,
                          userQuizResult,
                          setUserQuizResult
                      }) {
    let {tasks} = actualQuiz;

    function hideRightAnswer() {
        setShowAnswer(false);
        setUserAnswers(null);
        setUserTaskResult(<div/>);

        let checkBoxes = document.getElementsByClassName("answerCheckBox");
        for (let c of checkBoxes) {
            c.checked = false;
        }
    }

    function compareWithRightAnswers(rightAnswers, userAnswersDict) {
        let allRight = true;
        for (let r of rightAnswers) {
            let {rightAnswer} = r;
            if (rightAnswer !== userAnswersDict[r.id]) {
                allRight = false;
                break;
            }
        }

        if (allRight) {
            setUserTaskResult(<div className="alert alert-success mt-3" role="alert"
                                   style={{marginRight: '10%', marginLeft: '10%'}}>
                <i className="bi bi-check2"></i> Richtig!</div>);

            let right = userQuizResult["right"] + 1;
            let incorrect = userQuizResult["incorrect"];
            setUserQuizResult({"incorrect": incorrect, "right": right});
        } else {
            setUserTaskResult(<div className="alert alert-danger mt-3" role="alert"
                                   style={{marginRight: '10%', marginLeft: '10%'}}>
                <i className="bi bi-exclamation-triangle"></i> Falsch!</div>);

            let incorrect = userQuizResult["incorrect"] + 1;
            let right = userQuizResult["right"];
            setUserQuizResult({"incorrect": incorrect, "right": right});
        }
    }

    function checkAnswer(task) {
        let {answers} = task;
        setShowAnswer(true);
        let answerDict = {};
        for (let a of answers) {
            answerDict[a.id] = document.getElementById("answerCheckBox-" + a.id).checked;
        }
        setUserAnswers(answerDict);
        compareWithRightAnswers(answers, answerDict);
    }

    let tasksUI = [];
    let taskCounter = 0;
    for (let t of tasks) {
        let {answers} = t;
        let answersUI = [];
        for (let a of answers) {
            let {rightAnswer, term} = a;

            let answerClass = "list-group-item";
            if (showAnswer) {
                if (rightAnswer) {
                    answerClass = "list-group-item list-group-item-success";
                }
                if (!rightAnswer && userAnswers[a.id]) {
                    answerClass = "list-group-item list-group-item-danger";
                }
            }

            answersUI.push(
                <li id={"answer-" + a.id} key={"answer-" + a.id} className={answerClass}>
                    <input className="form-check-input me-1 answerCheckBox" type="checkbox" value=""
                           id={"answerCheckBox-" + a.id}/>
                    <label className="form-check-label stretched-link"
                           htmlFor={"answerCheckBox-" + a.id}>{term}</label>
                </li>
            );
        }

        let image = "";
        if (t.image !== undefined && t.image !== null) {
            image = <img src={"data:" + t.image.mimeType + ";base64," + t.image.content}
                         alt={t.image.name} style={{maxWidth: '60%', marginBottom: '1rem'}}/>;
        }

        let itemClassName = "carousel-item";
        if (taskCounter === 0) {
            itemClassName = "carousel-item active";
        }

        let checkAnswerButton = <button type="button" className="btn btn-outline-primary"
                                        onClick={() => checkAnswer(t)}>
            <i className="bi bi-check2-circle"></i> Antwort überprüfen
        </button>;
        if (showAnswer) {
            checkAnswerButton =
                <button type="button" className="btn btn-outline-primary" onClick={() => checkAnswer(t)} disabled>
                    <i className="bi bi-check2-circle"></i> Antwort überprüfen
                </button>;
        }

        tasksUI.push(
            <div key={"carousel-item-" + t.id} className={itemClassName}>
                <div key={"taskCard-" + t.id} className="card">
                    <div className="card-body">
                        <h4 className="card-title text-decoration-underline">
                            {(taskCounter + 1) + ". Aufgabe:"}
                        </h4>
                        <h5 className="card-title">
                            {t.question}
                        </h5>
                        {image}
                        <ul key={"list-group-answers-" + t.id} className="list-group"
                            style={{marginRight: '10%', marginLeft: '10%', marginBottom: '1rem'}}>
                            {answersUI}
                        </ul>
                        {userTaskResult}
                        {checkAnswerButton}
                    </div>
                </div>
            </div>
        );
        taskCounter++;
    }

    tasksUI.push(
        <div key={"carousel-item-result-" + actualQuiz.id} className="carousel-item">
            <div key={"taskCard-result-" + actualQuiz.id} className="card">
                <div className="card-body">
                    <h4 className="card-title text-decoration-underline" style={{marginBottom: '1rem'}}>
                        Ergebnis des Quiz:
                    </h4>
                    <div className="alert alert-success mt-3" role="alert"
                         style={{marginRight: '10%', marginLeft: '10%'}}>
                        <h5><i className="bi bi-check2"></i> {userQuizResult["right"]} richtige Antworten</h5></div>
                    <div className="alert alert-danger mt-3" role="alert"
                         style={{marginRight: '10%', marginLeft: '10%'}}>
                        <h5><i className="bi bi-exclamation-triangle"></i> {userQuizResult["incorrect"]} falsche
                            Antworten</h5></div>
                </div>
            </div>
        </div>
    );

    let carousel = <div id={"carouselQuiz-" + actualQuiz.id} className="carousel slide">
        <div className="carousel-inner">
            {tasksUI}
        </div>
        <button className="carousel-control-prev" type="button" data-bs-target={"#carouselQuiz-" + actualQuiz.id}
                data-bs-slide="prev" data-bs-theme="dark" onClick={hideRightAnswer}>
            <span className="badge text-wrap center"
                  style={{width: "7ch"}}><small><small><small>Vorherige Aufgabe</small></small></small></span>
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target={"#carouselQuiz-" + actualQuiz.id}
                data-bs-slide="next" data-bs-theme="dark" onClick={hideRightAnswer}>
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="badge text-wrap center" style={{width: "7ch"}}><small><small><small>Nächste Aufgabe</small></small></small></span>
        </button>
    </div>;

    return (
        <div>
            {carousel}
        </div>
    );
}

export default ActualCourse;